<template>
<div>
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="border-radius: 30px">

      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h3 class="modal-title">Credits</h3>
      </div>

      <div class="modal-body">
        <p><b>Game concept by</b> Dr. John Anvik</p>
        <p><b>Version 1.0 coded by</b>
          <br>
          Dustin Fowler, Jonathan Vos, Josh Vandenhoek,
          Lance Chisholm, and Shaun Cullen
        </p>
        <p><b>Current version by</b>
          <br>
          Jace Riehl, Vincent Cote, Shaun Cullen, and Dr. John Anvik
        </p>
        <p><b>Graphics by</b> John Anvik Jr., Katherine Hatton</p>
        <p><b>Follow the project page on </b>
          <a href="https://github.com/johnanvik/program-wars" target="_blank">GitHub</a>
        </p>
      </div>

      <div class="modal-footer">
        <div style="text-align: left; float: left; font-size: 85%">
          <p><b>Current Version: </b>
            <a href="https://github.com/johnanvik/program-wars/releases/latest"
                target="_blank">
              <img src="https://img.shields.io/github/release/johnanvik/program-wars.svg"
                  alt="versionNumber">
            </a>
          </p>
        </div>
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
            style="float: right">Close</button>
      </div>

    </div>
  </div>
</div>
</template>

<script>
/**
 * Modal to display the program credits.
 */
export default {}
</script>
